/* Angular Component */
import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { UI } from "../../../services/ui.service";
import { SearchService } from "../../../services/search.service";
import { Router } from "@angular/router";
import { UserService } from "app/js/src/domain/user-service";

@Component({
  selector: "library-header",
  templateUrl: "./libraryHeader.component.html",
  styleUrls: ["./libraryHeader.component.scss"],
})
export class LibraryHeaderComponent {
  @Output()
  onListModeChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  isMAMEditor: boolean;
  constructor(
    private ui: UI,
    private searchService: SearchService,
    private userService: UserService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.isMAMEditor = this.userService.getCurrentUser().hasEditMAMPermission;
  }

  toggleFilter() {
    this.ui.notify(this.ui.EVENTS.LibraryFilterToggle, {
      source: "LibraryHeaderFilerButton",
    });
  }

  /**
   * dispatch a callback to father component when user choose to change list view
   * @return void
   */
  onListModeToggleClick() {
    this.onListModeChange.emit(true);
  }
  onExternalMAMClick() {
    this.router.navigate(["/external-mam"]);
  }

  isFiltered(): "hidden" | "visible" {
    return this.searchService.isFiltered();
  }
}
